module.exports = __webpack_public_path__ + "static/media/003.d64496e9.jpg";